import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';

import { tap, switchMap } from 'rxjs/operators';
import { LocalStorage } from '@ngx-pwa/local-storage';

import { PayloadService } from '../payload/payload.service';

@Injectable({
    providedIn: 'root'
})
export class RechargesService {

    public payload;

    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage,
        public payloadService: PayloadService
    ) { }

    list(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "recharges/list", {
                        "payload": payload
                    });
                }
            )
        )
    }

    createLink(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "recharges/createLink", {
                        "payload": payload
                    });
                }
            )
        )
    }
}
